/**
*
* IconHolder
*
*/

import React, { useCallback, MouseEvent } from 'react';

import IconHolderWrapper from './styles/IconHolderWrapper';
import IconTitle from './styles/IconTitle';
import { browserHistory } from 'react-router';

type IconHolderProps = {
  thisStylesWrapper?: string,
  iconStyles?: string | object,
  onClick?: (val: object | string) => void,
  value?: string,
  href?: string,
  isDisabled?: boolean,
  isInternal?: boolean,
  isSending?: boolean,
  attr?: string,
  icon?: string,
  title?: string,
  iconStylesHover?: object,
  thisStylesHover?: object,
  data?: object,
  target?: string,
  thisStyles?: string | object,
}


function IconHolder({
  thisStylesWrapper,
  iconStyles,
  onClick,
  value,
  href,
  isDisabled,
  isInternal,
  isSending,
  attr,
  icon,
  title,
  iconStylesHover,
  thisStylesHover,
  data,
  target
}: IconHolderProps) {

  if (!icon) return;

  const handleClick = useCallback((event: MouseEvent<HTMLButtonElement>) => {
    
    if (href && !isInternal || isSending) return;

    event.preventDefault();
    event.stopPropagation();


    if (isDisabled) return;

    if (onClick) return onClick(data ? data : value ? value : attr);

    if (href) return browserHistory.push(href);
    
  },[value, attr, href, isDisabled, isInternal, isSending, data, onClick])


  const IconComponent = icon ? icon : null;

  return (
    <IconHolderWrapper 
      href={href}
      as={href ? 'a' : null}
      $iconStyles={iconStyles}
      $iconStylesHover={iconStylesHover}
      $thisStylesHover={thisStylesHover}
      $thisStylesWrapper={thisStylesWrapper}
      onClick={onClick ? handleClick : null}
      target={target}
    >
      <IconComponent />
      {title && <IconTitle>{title}</IconTitle>}
    </IconHolderWrapper>
  );
};


export default IconHolder;
